export enum WorkspaceNonTaggableType {
    LINK = 'LINK',
    APP = 'APP',
    UNKNOWN = 'UNKNOWN',
}
